import { BankAccount, BankTransaction } from "~/types/user";

export const bankAccounts: BankAccount[] = [
  {
    id: "1",
    bankName: "Banco Santander",
    accountNumber: "•••• 4582",
    balance: 165420.75,
    lastTransaction: {
      date: "2023-08-15",
      amount: -2500.0,
      description: "Transfer to Supplier",
    },
  },
  {
    id: "2",
    bankName: "Banco de Chile",
    accountNumber: "•••• 7823",
    balance: 98750.42,
    lastTransaction: {
      date: "2023-08-14",
      amount: 15000.0,
      description: "Client Payment",
    },
  },
  {
    id: "3",
    bankName: "Banco BICE",
    accountNumber: "•••• 3349",
    balance: 42680.9,
    lastTransaction: {
      date: "2023-08-13",
      amount: -1200.0,
      description: "Utility Payment",
    },
  },
];

export const bankTransactions: BankTransaction[] = [
  {
    id: "t1",
    accountId: "1",
    date: "2023-08-15",
    amount: -2500.0,
    description: "Transfer to Supplier",
    reference: "INV-78923",
    type: "expense",
  },
  {
    id: "t2",
    accountId: "1",
    date: "2023-08-13",
    amount: 12000.0,
    description: "Client Payment - Petrobras",
    reference: "PAY-6532",
    type: "income",
  },
  {
    id: "t3",
    accountId: "1",
    date: "2023-08-10",
    amount: -1750.0,
    description: "Office Equipment",
    reference: "PO-89201",
    type: "expense",
  },
  {
    id: "t4",
    accountId: "2",
    date: "2023-08-14",
    amount: 15000.0,
    description: "Client Payment - Shell",
    reference: "PAY-7801",
    type: "income",
  },
  {
    id: "t5",
    accountId: "2",
    date: "2023-08-11",
    amount: -4200.0,
    description: "Utility Bills",
    reference: "UTIL-293",
    type: "expense",
  },
  {
    id: "t6",
    accountId: "3",
    date: "2023-08-13",
    amount: -1200.0,
    description: "Utility Payment",
    reference: "UTIL-294",
    type: "expense",
  },
  {
    id: "t7",
    accountId: "3",
    date: "2023-08-10",
    amount: 8500.0,
    description: "Client Payment - ExxonMobil",
    reference: "PAY-6589",
    type: "income",
  },
];

export const getCurrentTotalBalance = () => {
  return bankAccounts.reduce((total, account) => total + account.balance, 0);
};

export const getTransactionsForAccount = (accountId: string) => {
  return bankTransactions.filter(
    (transaction) => transaction.accountId === accountId
  );
};

export const getRecentTransactions = (limit: number = 10) => {
  return [...bankTransactions]
    .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
    .slice(0, limit);
};
